/**
 * MKS-447 (part 6) — the reconciliation report hook.
 *
 * A mutation rather than a query, even though the endpoint reads and writes
 * nothing: the batch it compares is in the REQUEST BODY, supplied by the
 * admin, so there is no stable key to cache under and no "current" report to
 * refetch. Running it is the user's action, which is exactly what `useMutation`
 * models — and it keeps TanStack Query from re-posting a multi-megabyte batch
 * on every window focus.
 */
import { useMutation } from '@tanstack/react-query';
import {
  reconcileLinearIssues,
  type LinearReconciliationReport,
} from '../services/api/linearReconciliation';

export function useLinearReconciliation() {
  return useMutation<LinearReconciliationReport, Error, unknown[]>({
    mutationFn: (issues: unknown[]) => reconcileLinearIssues(issues),
  });
}
